export const clearReducers = () => ({
  type: 'CLEAR_REDUCERS'
});
